// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DZa_","question":"styles_question__VrRT2","description":"styles_description__2ts4y"};